/**
 * Endpoint configuration for ai-notes-extractor calls.
 *
 * - Production: integration-gateway.genealogie.app/api/ai-notes —
 *   the integration gateway intercepts, validates CORS, and injects
 *   the Bearer token server-side before forwarding to the worker.
 * - Development: direct workers.dev URL with Bearer from
 *   AI_NOTES_DEV_TOKEN (.env.development.local).
 */

const isProd = process.env.NODE_ENV === 'production';

export const AI_NOTES_ENDPOINT = isProd
  ? 'https://integration-gateway.genealogie.app/api/ai-notes'
  : 'https://ai-notes-extractor.genealogie.workers.dev';

export function aiNotesHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  if (!isProd && process.env.AI_NOTES_DEV_TOKEN) {
    headers['Authorization'] = `Bearer ${process.env.AI_NOTES_DEV_TOKEN}`;
  }
  return headers;
}
